import { inject } from 'vue';
import { getServerState } from '../state';
import { getLogger } from '../logger';
export const routerStateKey = 'zsc-plugin-vite-ssr-router';
/** @internal */
const routeSymbol = Symbol.for('zsc-vite-plugin-ssr: current route');
/**
 * The router plugin provides information about the current route and is
 * automatically installed by zsc-plugin-vite-ssr
 *
 * @internal
 */
export const routerPlugin = {
    install(app) {
        const route = getServerState(routerStateKey, app.config.globalProperties.$appId);
        if (!route) {
            getLogger().error('Failed to find current route information in server state, route plugin could not be installed');
            return;
        }
        app.config.globalProperties.$route = route;
        app.provide(routeSymbol, route);
    },
};
/**
 * Returns information about the current route
 */
export function useRoute() {
    const rr = inject(routeSymbol);
    if (rr == null)
        return undefined;
    return {
        ...rr,
        searchParams: new URLSearchParams(rr.search),
    };
}
//# sourceMappingURL=router.js.map